<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import __OrderDetailsSummary, {OrderDetailsSummary as _OrderDetailsSummary} from '~src/components/account/OrderDetailsSummary.vue'

    @Component({mixins: [__OrderDetailsSummary]})
    export class OrderDetailsSummary extends _OrderDetailsSummary {
        // UI-23 (Point D - Stay Duration Wording): show only nights in the order
        // summary duration, dropping the leading "X days / " that core renders
        // (e.g. "3 days / 2 nights" -> "2 nights"). Core behavior unchanged for
        // other builds.
        get duration() {
            if (!this.maxDate && !this.minDate) return null

            const day = this.$dateFns.differenceInCalendarDays(new Date(this.maxDate), new Date(this.minDate)) + 1
            const night = day > 1 ? day - 1 : 1

            return night + ` ${this.$t('night', night)}`
        }
    }

    export default {...toNative(OrderDetailsSummary), ssrRender: __OrderDetailsSummary.ssrRender}
</script>
